import { render } from "./Service.vue?vue&type=template&id=061ae30f"
const script = {}
script.render = render

export default script